module.exports = __webpack_public_path__ + "img/home_title1.3af79174.png";